var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCircle = function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 10 7.5 6v8zm-2.862 0L9 8.684v2.632z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 16.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m0 1.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16",
    clipRule: "evenodd"
  })));
};
export { SvgPlayCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAxMEw3LjUgNlYxNEwxNCAxMFpNMTEuMTM3OSAxMEw5IDguNjg0MzVWMTEuMzE1N0wxMS4xMzc5IDEwWiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwIDE2LjVDMTMuNTg5OSAxNi41IDE2LjUgMTMuNTg5OSAxNi41IDEwQzE2LjUgNi40MTAxNSAxMy41ODk5IDMuNSAxMCAzLjVDNi40MTAxNSAzLjUgMy41IDYuNDEwMTUgMy41IDEwQzMuNSAxMy41ODk5IDYuNDEwMTUgMTYuNSAxMCAxNi41Wk0xMCAxOEMxNC40MTgzIDE4IDE4IDE0LjQxODMgMTggMTBDMTggNS41ODE3MiAxNC40MTgzIDIgMTAgMkM1LjU4MTcyIDIgMiA1LjU4MTcyIDIgMTBDMiAxNC40MTgzIDUuNTgxNzIgMTggMTAgMThaIi8+Cjwvc3ZnPgo=";